import React, { useEffect, useState } from 'react';
import TextToSpeech from './components/TextToSpeech';
// import ProductGrid from './components/ProductGrid';
import { getUserLocation } from './services/getUserLocation'; // import service

const App = () => {

    const [countryCode, setCountryCode] = useState('');

    useEffect(() => {
      const fetchLocation = async () => {
        const code = await getUserLocation();
        setCountryCode(code);
      };
      fetchLocation();
    }, []);

    return (
      <>
      <TextToSpeech/>
      {/* {countryCode === 'US' && <ProductGrid />} */}
      </>
    );
};

export default App;
